import { render, staticRenderFns } from "./AdminBlogs.vue?vue&type=template&id=1f896ede"
import script from "./AdminBlogs.vue?vue&type=script&lang=js"
export * from "./AdminBlogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports